import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
import { createPortal } from 'react-dom';
import FocusLock from 'react-focus-lock';
import { TransitionGroup } from 'react-transition-group';
import Blanket from '@cmpkit/blanket';
import { drawerVariants } from '../variants';
import { Fade, Slide } from './Transitions';
const Wrapper = (_a) => {
    var { size, position, orient, className } = _a, props = __rest(_a, ["size", "position", "orient", "className"]);
    return (React.createElement("div", Object.assign({ role: 'dialog', className: clsx('drawer-wrapper', drawerVariants({
            position,
            size,
            orient,
        }), className) }, props)));
};
function DrawerContent(_a) {
    var { in: inProp, children, onCloseComplete, shouldUnmountOnExit, disableFocusTrap } = _a, props = __rest(_a, ["in", "children", "onCloseComplete", "shouldUnmountOnExit", "disableFocusTrap"]);
    return (React.createElement(Slide, Object.assign({ in: inProp, component: Wrapper, onExited: onCloseComplete, shouldUnmountOnExit: shouldUnmountOnExit }, props),
        React.createElement(FocusLock, { disabled: !inProp || disableFocusTrap }, children)));
}
function Drawer({ size = 'medium', orient = 'left', position = 'fixed', root = document.body, onClose, isOpen, children, shouldUnmountOnExit, disablePortal, disableBlanket, disableFocusTrap, onCloseComplete, className, }) {
    const handleBlanketClick = () => handleClose();
    const handleClose = () => onClose === null || onClose === void 0 ? void 0 : onClose();
    if (!root) {
        return null;
    }
    const content = (React.createElement(TransitionGroup, null,
        React.createElement(React.Fragment, null,
            disableBlanket ? null : (React.createElement(Fade, { in: isOpen, position: position },
                React.createElement(Blanket, { className: position, isTinted: true, onBlanketClicked: handleBlanketClick }))),
            React.createElement(DrawerContent, { in: isOpen, className: className, orient: orient, position: position, onClose: handleClose, onCloseComplete: onCloseComplete, size: size, disableFocusTrap: disableFocusTrap, shouldUnmountOnExit: shouldUnmountOnExit }, children))));
    if (disablePortal) {
        return content;
    }
    return createPortal(content, root);
}
export { Drawer };
//# sourceMappingURL=Drawer.js.map